import { render, staticRenderFns } from "./bto-details.vue?vue&type=template&id=1cba9d86&scoped=true&"
import script from "./js/bto-details.js?vue&type=script&lang=js&"
export * from "./js/bto-details.js?vue&type=script&lang=js&"
import style0 from "./bto-details.vue?vue&type=style&index=0&id=1cba9d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba9d86",
  null
  
)

export default component.exports